import { IDataEndPoint, IEntityEndPoints, IFieldOptions, IFormOptions, IGridOptions, IColumnOptions, IEntityOptions } from '@framework/interfaces/IEntity';
import * as app from '@framework/app';
import * as models from '@common/domain/models/StockItemSupplierDTO';
import { IApiServiceCommand } from '@services/api/api.service';
export class StockItemSupplierEndPoints implements IEntityEndPoints {
	list?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/stockItemSupplier"}, method: "GET" };
	get?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/stockItemSupplier/" + serviceCommand.context.entityId}, method: "GET" };
	update?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/stockItemSupplier/update/" + serviceCommand.context.entityId}, method: "POST" };
	search?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/stockItemSupplier/lazy/"}, method: "POST" };
	pagingTotalCount?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/stockItemSupplier/lazyCount/"}, method: "POST" };
	insert?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/stockItemSupplier/create"}, method: "POST" };
	delete?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/stockItemSupplier/delete/"+ serviceCommand.context.entityId}, method: "POST" };
}

export class StockItemSupplierFormFields extends Array<IFieldOptions> {
	public id: IFieldOptions = { field: "id" };
	public status: IFieldOptions = { field: "status" };
	public datestamp: IFieldOptions = { field: "datestamp" };
	public changedById: IFieldOptions = { field: "changedById" };
	public stockItemId: IFieldOptions = { field: "stockItemId" };
	public supplierId: IFieldOptions = { field: "supplierId" };
	public code: IFieldOptions = { field: "code" };
	public price: IFieldOptions = { field: "price" };
	constructor() {
		super();
		this.push(this.id);
		this.push(this.status);
		this.push(this.datestamp);
		this.push(this.changedById);
		this.push(this.stockItemId);
		this.push(this.supplierId);
		this.push(this.code);
		this.push(this.price);
	}
}

export class StockItemSupplierForm implements IFormOptions {
	protected stockItemSupplierFormName: string = "stockItemSupplierForm";
	protected stockItemSupplierFormModel: models.StockItemSupplierDTO = new models.StockItemSupplierDTO();
	protected stockItemSupplierFormEndPoints: StockItemSupplierEndPoints = new StockItemSupplierEndPoints();
	protected stockItemSupplierFormFields: StockItemSupplierFormFields = new StockItemSupplierFormFields();
	public get name(): string { return this.stockItemSupplierFormName };
	public get model(): models.StockItemSupplierDTO { return this.stockItemSupplierFormModel };
	public get endPoints(): IEntityEndPoints { return this.stockItemSupplierFormEndPoints };
       public set endPoints(stockItemSupplierEndPoints: IEntityEndPoints) {
		this.stockItemSupplierFormEndPoints = stockItemSupplierEndPoints;
	};
	public get dataEndPoint(): IDataEndPoint { return this.endPoints.get };
	public get fields(): StockItemSupplierFormFields { return this.stockItemSupplierFormFields };
}

export class StockItemSupplierListColumns extends Array<IColumnOptions> {
	public id: IColumnOptions = { field: "id" };
	public status: IColumnOptions = { field: "status" };
	public datestamp: IColumnOptions = { field: "datestamp", template: function (fldValue) { return (new Date(fldValue)["shortDate"]()).toString(); } };
	public changedById: IColumnOptions = { field: "changedById" };
	public stockItemId: IColumnOptions = { field: "stockItemId" };
	public supplierId: IColumnOptions = { field: "supplierId" };
	public code: IColumnOptions = { field: "code" };
	public price: IColumnOptions = { field: "price" };
	constructor() {
		super();
		this.push(this.id);
		this.push(this.status);
		this.push(this.datestamp);
		this.push(this.changedById);
		this.push(this.stockItemId);
		this.push(this.supplierId);
		this.push(this.code);
		this.push(this.price);
	}
}

export class StockItemSupplierList implements IGridOptions {
	protected stockItemSupplierListName: string = "stockItemSupplierList";
	protected stockItemSupplierListModel: models.StockItemSupplierDTO = new models.StockItemSupplierDTO();
	protected stockItemSupplierListEndPoints: StockItemSupplierEndPoints = new StockItemSupplierEndPoints();
	protected stockItemSupplierListColumns: StockItemSupplierListColumns = new StockItemSupplierListColumns();
	public stockItemSupplierForm: StockItemSupplierForm = new StockItemSupplierForm();
	public get name(): string { return this.stockItemSupplierListName };
	public get model(): models.StockItemSupplierDTO { return this.stockItemSupplierListModel };
	public get endPoints(): IEntityEndPoints { return this.stockItemSupplierListEndPoints };
	public set endPoints(stockItemSupplierEndPoints: IEntityEndPoints) {
		this.stockItemSupplierListEndPoints = stockItemSupplierEndPoints;
		this.stockItemSupplierForm.endPoints = this.endPoints;
	};
	public get dataEndPoint(): IDataEndPoint { return this.endPoints.list };
	public get columns(): StockItemSupplierListColumns { return this.stockItemSupplierListColumns };
}

export class StockItemSupplierEntity implements IEntityOptions {
	protected stockItemSupplierEntityName: string = "stockItemSupplierEntity";
	protected stockItemSupplierEntityModel: models.StockItemSupplierDTO = new models.StockItemSupplierDTO();
	protected stockItemSupplierEntityEndPoints: StockItemSupplierEndPoints = new StockItemSupplierEndPoints();
	protected stockItemSupplierEntityList: StockItemSupplierList = new StockItemSupplierList();
	public get name(): string { return this.stockItemSupplierEntityName };
	public get model(): models.StockItemSupplierDTO { return this.stockItemSupplierEntityModel };
	public get endPoints(): IEntityEndPoints { return this.stockItemSupplierEntityEndPoints };
	public set endPoints(stockItemSupplierEndPoints: IEntityEndPoints) {
		this.stockItemSupplierEntityEndPoints = stockItemSupplierEndPoints;
		this.grid.endPoints = this.endPoints;
	};
	public get grid(): StockItemSupplierList { return this.stockItemSupplierEntityList };
	public get form(): StockItemSupplierForm { return this.grid.stockItemSupplierForm };
	constructor(name?: string) {
		if (name) this.stockItemSupplierEntityName = name;
		this.endPoints = this.stockItemSupplierEntityEndPoints;
	}
};
//export class StockItemSupplierGeneratedForm extends MfGeneratedFormComponent {
 // protected detailPageComponentForm: StockItemSupplierForm = new StockItemSupplierForm();
//};

//export class StockItemSupplierListPageComponent extends ListPageComponent {
  //protected listPageComponentList: StockItemSupplierList = new  StockItemSupplierList();
  //protected showFilterColOnTable: boolean = true;
//};

//export class StockItemSupplierBlade extends MfBladeComponent {
  //protected detailComponents: Array<IDetailComponent> = [ { index: 0, displayName: "Properties", component: StockItemSupplierGeneratedForm}];
//};

//export class StockItemSupplierListBlade extends MfBladeComponent {
 // protected detailComponents: Array<IDetailComponent> = [ { index: 0, displayName: "Properties", component: StockItemSupplierListPageComponent, isMenuHidden: true }];
//};

